module.exports = __webpack_public_path__ + "static/media/15-goals.a91dc093.png";